const mainPhone = '+593969120722';

export const CONFIG = {
    phone: mainPhone,
    phoneSecondary: mainPhone,
    appName: 'Fast Drive',
    email: 'autofastuio@gmail.com',
    instagram: 'https://instagram.com/autofast_alquilerdevehiculos?igshid=YmMyMTA2M2Y=',
    whatsapp: `https://wa.me/593969120722?text=`,
    address: 'Av Eloy Alfaro y de las Anonas Torres Santa Catalina'
}
export const siteRCK = '6LepcQchAAAAAMz_HSVYiMyN5lSkkqjTfdS2ansL'